import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Footer from "./Components/Footer";
import Header from "./Components/Header";
import HomePage from "./Pages/Home";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import SitePlans from "./Pages/SitePlans";
import TrilliumStreet from "./Pages/TrilliumStreet";
import PageLoader from "./Components/PageLoader";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import TermsOfService from "./Pages/TermsOfService";
import { useEffect, useState } from "react";

function App() {
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    if (sessionStorage.getItem("pageLoaderShown")) {
      setShowLoader(false);
    } else {
      sessionStorage.setItem("pageLoaderShown", "true");
      setTimeout(() => setShowLoader(false), 2000);
    }
  }, []);
  return (
    <BrowserRouter>
      {showLoader && <PageLoader />}
      {!showLoader && (
        <>
          <Header/>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about-townbell" element={<About />} />
            <Route path="/amayra-trillium" element={<SitePlans />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/amayra-trillium-street" element={<TrilliumStreet />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
          </Routes>
          <Footer />
        </>
      )}
    </BrowserRouter>
  );
}

export default App;
